import { render, staticRenderFns } from "./CargaTab.vue?vue&type=template&id=47a12a8a"
import script from "./CargaTab.vue?vue&type=script&lang=js"
export * from "./CargaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports